var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col l4 m4 s12"}),_c('div',{staticClass:"col l4 m4 s12 align-center"},[_c('div',{staticClass:"copyright"},[_vm._v(" © SuitsIn, "),_c('span',{staticClass:"yearN"},[_vm._v(_vm._s(_vm.yearNow))])])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }